<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="body-content-overlay"></div>
        <!-- Main contact area -->
        <section class="chat-app-window">
          <!-- To load Conversation -->
          <div v-if="!contactInfo.full_name" class="start-chat-area">
            <div class="mb-1 start-chat-icon">
              <i data-feather="message-square"></i>
            </div>
            <h4 class="sidebar-toggle start-chat-text">Select Patient</h4>
          </div>
          <!--/ To load Conversation -->

          <!-- Active Contact -->
          <div v-if="contactInfo.full_name" class="active-chat">
            <!-- Contact Header -->
            <div class="chat-navbar">
              <header class="chat-header">
                <div class="d-flex align-items-center">
                  <div @click="$emit('sidebarActiveInactive')" class="sidebar-toggle d-block d-lg-none me-1">
                    <img src="/app-assets/images/icons/dental/patient-side-icon.svg" alt="" width="24" height="24">
                  </div>
                  <div class="avatar avatar-border user-profile-toggle m-0 me-1">
                    <img :src="contactInfo.photo" width="42" class="border-0" :alt="contactInfo.full_name"/>
                  </div>
                  <h6 class="mb-0">
                    {{ contactInfo.full_name }}<br>
                    <small v-for="profile_item in contactInfo.profile_items">
                      {{ profile_item.value }}<br>
                    </small>
                  </h6>
                </div>
               <div class="d-flex">
                 <div @click="goRoute('sticker-printer')" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="tab" class="btn btn-success">Sticker Printer</h5>
                 </div>
                 <div @click="goRoute('patient-card-print')" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="tab" class="btn btn-primary">Patient Card</h5>
                 </div>
                 <div @click="$emit('handleEdit', contactInfo)" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="button" class="btn btn-dark">Profile</h5>
                 </div>
               </div>
              </header>
            </div>
            <!--/ Contact Header -->

            <!-- User Chat messages -->
            <div class="user-chats">
              <div class="chats">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :class="['nav-link', { active: activeTabId === tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                  </li>
                </ul>
                <component :is="activeTab" :contactDetails="contactDetails" :contactInfo="contactInfo"/>
              </div>
            </div>
            <!-- User Contact messages -->
          </div>
          <!--/ Active Contact -->
        </section>
        <!--/ Main contact area -->
      </div>
    </div>
  </div>
</template>

<script setup>
import Treatment from '@/components/molecule/company/dental-os/single-service/patients/tabs/Treatment.vue'
import Dentition from '@/components/molecule/company/dental-os/single-service/patients/tabs/Dentition.vue'
import Billing from '@/components/molecule/company/dental-os/single-service/patients/tabs/Billing.vue'
import Note from '@/components/molecule/company/dental-os/single-service/patients/tabs/Note.vue'
import Attachment from '@/components/molecule/company/dental-os/single-service/patients/tabs/Attachment.vue'

import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import { shallowRef } from 'vue'

const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  }
})

const router = useRouter();
const route = useRoute();
const activeTabId = ref("treatment")
const activeTab = shallowRef(Treatment)

const tabs = [
  {id: 'treatment', title: 'Treatment', component: Treatment},
  {id: 'dentition', title: 'Dentition Status', component: Dentition},
  {id: 'billing', title: 'Billing & Payment', component: Billing},
  {id: 'attachment', title: 'Attachment', component: Attachment},
  {id: 'note', title: 'Note', component: Note},
]

watch(activeTabId, () => {
  activeTab.value = tabs.find(tab => tab.id === activeTabId.value).component
  let routeQuery = Object.assign({}, route.query)
  routeQuery.patient_tab = activeTabId.value;
  routeQuery.page = 1;
  router.push({
    path: route.path,
    query: routeQuery
  })
})

const setActiveTab = tab => {
  activeTabId.value = tab.id;
};

const goRoute = (routeName = 'sticker-printer') => {
  router.push({name: routeName, params: {patientId: props.contactInfo.id}})
}

onMounted(() => {
  if (route.query.patient_tab) {
    activeTabId.value = route.query.patient_tab;
  }
})

</script>

<style scoped>
.user-chats {
  background-image: none !important;
  overflow-y: scroll;
  height: calc(100% - 65px);
  overflow-x: hidden;
}
</style>
